import styled from "styled-components";
import { DonutChart } from "../DonutChart/DonutChart";
import { Radio, Select } from "antd";

export const DashboardWrapper = styled.div`
  padding: 24px;
  background-color: #ffffff;
  width: 100%;
  height: 100vh;
`;

export const ChartsWrapper = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: space-between;
`;

export const StyledDonutChart = styled(DonutChart)`
  flex-grow: 1;
`;

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items:center;
  justify-content:space-between;
  margin-bottom: 32px;
`;

export const StyledRating = styled.div`
  display: flex;
  flex-direction: column;
`;
export const StyledTadleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;

export const StyledStatusRow = styled.div`
  width: 100%;
  align-items: center;
  display: flex;
`;

export const StyledSelect = styled(Select)`
  width: 44%;
  font-weight: 400;
  font-size: 12px;

  &.arrow-icon {
    color: #8e9cbd;
  }

  &.ant-select-open .arrow-icon {
    transform: rotate(180deg);
  }

  .ant-select-selection-overflow {
    gap: 4px;
  }

  &.ant-select-selection-item {
   margin-top: 4px;
    height: 16px;
    color: #5F6A86;
  }

  .ant-select {
    margin-right: 12px;
    border-radius: 8px;
    border-color: #bdc5db;
    color: #4a5368;
  }

  .ant-select-selector {
    border: 1px solid #bdc5db !important;
    border-radius: 8px !important;
  }

  .ant-select-multiple {
    font-weight: 400;
    font-size: 12px;
  }
`;

export const StyledRadioGroup = styled(Radio.Group)`
  .ant-radio-button-checked {
    background-color: #e5f2ff;
    border-radius: 5px;
    color: #007bfb;
  }
`;
